<template>
  <section v-if="activity" class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Top contributors</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">Members who created or updated the most content this month.</p>

    <div v-if="contributors.length" class="overflow-x-auto">
      <table class="w-full text-sm border-collapse">
        <thead>
        <tr class="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wide text-gray-400">
          <th class="py-2 pr-4 font-semibold w-8">#</th>
          <th class="py-2 pr-4 font-semibold">Member</th>
          <th class="py-2 font-semibold">Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(c, index) in contributors" :key="c.user_id" class="border-b border-gray-100 hover:bg-gray-50">
          <td class="py-2 pr-4 text-gray-400">{{ index + 1 }}</td>
          <td class="py-2 pr-4 text-gray-700">{{ c.name }}</td>
          <td class="py-2 font-semibold text-gray-900">{{ c.count }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-sm text-gray-400 py-2">No contributions this month</div>
  </section>
</template>

<script>
  export default {
    name: 'HeartbeatTopContributors',
    props: {
      activity: Object,
    },
    computed: {
      contributors () {
        return (this.activity && this.activity.top_contributors) || []
      },
    },
  }
</script>
